export default __webpack_public_path__ + "static/media/Venturer's Bracers of Crouching Calm.5ae51c21.jpg";